import { render, staticRenderFns } from "./simOpenPayTest.vue?vue&type=template&id=f0008408&scoped=true&"
import script from "./simOpenPayTest.vue?vue&type=script&lang=js&"
export * from "./simOpenPayTest.vue?vue&type=script&lang=js&"
import style0 from "./simOpenPayTest.vue?vue&type=style&index=0&id=f0008408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0008408",
  null
  
)

export default component.exports